<template>
  <ListEditShell
    :config="config"
    :value-provider="valueProvider || noopValueProvider"
    :facet-provider="facetProvider || noopFacetProvider"
    :known-values="knownValues"
    :debounce-ms="debounceMs"
    :search-ui="searchUi"
    :simplify-when-small="simplifyWhenSmall"
    :small-threshold="smallThreshold"
    :controlled="controlled"
    :initial-query="initialQuery"
    @update:query="emit('update:query', $event)"
    @update:sort="emit('update:sort', $event)"
    @crumb="emit('crumb', $event)"
  >
    <template v-if="slots.instance" #instance="ctx"><slot name="instance" v-bind="ctx" /></template>
  </ListEditShell>
</template>

<script setup>
// ── AdminCollectionLayout ────────────────────────────────────────────────
// The public entry point: a thin, named wrapper over ListEditShell with admin
// defaults (searchUi="summary", auto-simplify for small collections, no-op FQL
// providers). Ported 1:1 from admin-collection-layout.jsx. Forwards the
// #instance scoped slot through to the panel.
import { useSlots } from 'vue'
import ListEditShell from './ListEditShell.vue'

const noopValueProvider = () => Promise.resolve([])
const noopFacetProvider = () => Promise.resolve([])

defineProps({
  config: { type: Object, required: true },
  valueProvider: { type: Function, default: null },
  facetProvider: { type: Function, default: null },
  knownValues: { type: Object, default: () => ({}) },
  debounceMs: { type: Number, default: 220 },
  searchUi: { type: String, default: 'summary' },
  simplifyWhenSmall: { type: Boolean, default: true },
  smallThreshold: { type: Number, default: 25 },
  controlled: { type: Boolean, default: false },
  // Forwarded whole: a query the host wants this screen to open on, ahead of
  // the one the shell remembers. See ListEditShell for what it displaces.
  initialQuery: { type: String, default: '' },
})
const emit = defineEmits(['update:query', 'update:sort', 'crumb'])
const slots = useSlots()
</script>
